import { Button } from "@msuite/ui/button";
import { Divider } from "@msuite/ui/divider";
import { useDisclosure } from "@msuite/ui/hooks";
import { AlertIcon, Icon } from "@msuite/ui/icons";
import { useTranslation } from "@msuite/ui/localization";
import React from "react";
import { IntegrationForm } from "@/forms/integration-form";
import { useCitadel } from "@/hooks/use-citadel";
import type { ThirdPartyIntegrationStateProps } from "./types";

export function ThirdPartyIntegrationNotActive({
	refetch,
	integrationType,
}: ThirdPartyIntegrationStateProps) {
	/** Hooks */
	const disclosure = useDisclosure();
	const { t } = useTranslation();
	const { citadel } = useCitadel();

	/** Computed */
	// Storing credentials is `create Integration`, which reading the tab is not. Without it the
	// card still reports that nothing is set up; the form that would 403 on submit is not offered.
	const canCreateIntegration = citadel?.can("create", "Integration") === true;

	/** Render */
	return (
		<div className="v-stack">
			<div className="h-stack justify-between">
				<div className="h-stack gap-4 items-center">
					<AlertIcon />
					<p>{t("integrations.integration_not_active")}</p>
				</div>
				{canCreateIntegration && (
					<Button
						icon={<Icon name="Zap" />}
						stopPropagation
						onClick={disclosure.onOpen}
					>
						{t("integrations.setup_integration")}
					</Button>
				)}
			</div>
			{disclosure.isOpen && (
				<React.Fragment>
					<Divider variant="content-card" />
					<IntegrationForm
						integrationType={integrationType}
						refetch={refetch}
					/>
				</React.Fragment>
			)}
		</div>
	);
}
